import React from 'react';
import './HomeDescription.css';

const cards = [
  { icon: 'wallet.png',   alt: 'Pagamento imediato',      text: 'Pagamento imediato' },
  { icon: 'like.png',     alt: 'Negociação transparente', text: 'Negociação transparente, segura e sem burocracia' },
  { icon: 'workbank.png', alt: 'Procedimento online',     text: 'Procedimento 100% online' },
  { icon: 'proft.png',    alt: 'Alta liquidez',           text: 'Cota de consórcio em ativo de alta liquidez' },
];

function Card({ icon, alt, text, className = '' }) {
  return (
    <div
      className={`rounded-xl shadow-lg flex flex-col justify-center items-center p-6 text-center border-t-4 ${className}`}
      style={{
        borderColor: '#c76f36',
        backgroundColor: 'rgba(255, 255, 255, 0.82)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
      }}
    >
      <div
        className='w-16 h-16 rounded-full flex items-center justify-center mb-3 flex-shrink-0'
        style={{ backgroundColor: 'rgba(199,111,54,0.08)' }}
      >
        <img className='h-10 w-10 object-contain' src={icon} alt={alt} />
      </div>
      <span className='font-raleway font-semibold text-sm text-gray-700 leading-snug'>{text}</span>
    </div>
  );
}

function HomeDescription() {
  return (
    <>
      {/* Desktop */}
      <div className='flex space-x-5 mx-auto my-auto h-sm:hidden'>
        {cards.map((card) => (
          <Card key={card.text} {...card} className='h-48 w-60' />
        ))}
      </div>

      {/* Mobile */}
      <div className='w-full px-6 space-y-4 h-sm:block hidden'>
        <div className='flex space-x-4'>
          {cards.slice(0, 2).map((card) => (
            <Card key={card.text} {...card} className='w-1/2 h-44' />
          ))}
        </div>
        <div className='flex space-x-4'>
          {cards.slice(2).map((card) => (
            <Card key={card.text} {...card} className='w-1/2 h-44' />
          ))}
        </div>
      </div>
    </>
  );
}

export default HomeDescription;
